document.querySelectorAll('.concours-slider').forEach((slider) => {
  const slides = slider.querySelectorAll('.concours-slider__slide');
  const thumbs = slider.querySelectorAll('.concours-slider__thumb');
  const prev = slider.querySelector('.concours-slider__arrow--prev');
  const next = slider.querySelector('.concours-slider__arrow--next');
  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (thumbs[current]) thumbs[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (thumbs[current]) thumbs[current].classList.add('is-active');
  }

  const isCardSlider = slider.classList.contains('concours-card__slider');
  const delay = isCardSlider ? 5000 : 4000;
  let autoplay = setInterval(() => goTo(current + 1), delay);

  function resetAutoplay() {
    clearInterval(autoplay);
    autoplay = setInterval(() => goTo(current + 1), delay);
  }

  if (prev) prev.addEventListener('click', () => { goTo(current - 1); resetAutoplay(); });
  if (next) next.addEventListener('click', () => { goTo(current + 1); resetAutoplay(); });
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => { goTo(Number(thumb.dataset.index)); resetAutoplay(); });
  });
});
